/**
 * Типы сообщений чата
 */
export default class ChatMessagesTypes
{
    public static readonly MESSAGE_TYPE_VOTE = 1;
    public static readonly MESSAGE_TYPE_PLAYER_ACTION = 2;
    public static readonly MESSAGE_TYPE_SYSTEM_MESSAGE = 3;
    public static readonly MESSAGE_TYPE_SECTION_MESSAGE = 8;
    public static readonly MESSAGE_TYPE_IMPORTANT_MESSAGE = 7;
}
